import $ from 'jquery';

$(document.body).WCBackboneModal({
    template: 'sheerid_activation_modal'
});